import * as state from '@/components/AssetLabelling/state';
import { CuboidState } from '@/modules/cuboids/types';
import * as globalState from '@/state';
import { LabellingCuboid } from '@/types';

const { currentCuboid, cuboids, cuboidResizeStep } = state;

const {
  cuboidClickMode,
  cuboidTransformMode,
  isCuboidEditorEnabled,
  isCuboidVisibilityBoxEnabled,
  referenceCuboid,
  isAddingWorkscope,
} = globalState;

const cuboidState = {
  currentCuboid,
  cuboids,
  cuboidClickMode,
  cuboidTransformMode,
  isCuboidEditorEnabled,
  isCuboidVisibilityBoxEnabled,
  referenceCuboid,
  isAddingWorkscope,
  cuboidResizeStep,
};

export const useCuboidState = (): CuboidState<LabellingCuboid> => {
  return cuboidState;
};
